/**
 * 權限格式工具
 * API Schema 要求權限格式為 ^[a-z0-9_]+:(create|read|update|delete|export|print)$
 * 三段式 (module:submodule:action) 需轉為二段式 (module_submodule:action)
 * 例如: chatmate:knowledge:read -> chatmate_knowledge:read
 */

const THREE_PART_PATTERN = /^([a-z0-9_]+):([a-z0-9_]+):(create|read|update|delete|export|print)$/;

/**
 * 將三段式權限轉為二段式
 * @param {string} permission - 權限字串
 * @returns {string} 轉換後的權限字串
 */
export function normalizePermission(permission) {
  if (!permission || typeof permission !== 'string') return permission;
  const match = permission.match(THREE_PART_PATTERN);
  if (match) {
    return `${match[1]}_${match[2]}:${match[3]}`;
  }
  return permission;
}

/**
 * 將權限陣列中的三段式權限轉為二段式
 * @param {Array<string|null>} permissions - 權限陣列
 * @returns {Array<string|null>} 轉換後的權限陣列
 */
export function normalizePermissions(permissions) {
  if (!permissions || !Array.isArray(permissions)) return permissions;
  return permissions.map(p => (p ? normalizePermission(p) : p));
}

/**
 * 將 programPermissions 物件中的權限陣列轉為 API 接受的格式
 * @param {Object} programPermissions - { programId: [permission1, ...] 或 null }
 * @returns {Object} 轉換後的 programPermissions
 */
export function normalizeProgramPermissions(programPermissions) {
  if (!programPermissions || typeof programPermissions !== 'object') return programPermissions;
  const result = {};
  Object.keys(programPermissions).forEach(programId => {
    const perms = programPermissions[programId];
    if (perms === null) {
      result[programId] = null;
    } else if (Array.isArray(perms) && perms.length > 0) {
      result[programId] = normalizePermissions(perms);
    } else {
      result[programId] = perms;
    }
  });
  return result;
}
